import { doHttp, doHttp2 } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../utils/config'

/**
 * 新增/编辑 标签
 * @param params
 * @return {*}
 */
export function apiEdit (params) {
  return doHttp('/labelField/edit.action', HTTP_TYPE_POST, params)
}

/**
 * 列表
 * @param companyId
 * @return {*}
 */
export function apiList (companyId) {
  let params = { companyId }
  return doHttp('/labelField/list.action', HTTP_TYPE_GET, params)
}

/**
 * 列表2
 * @param companyId
 * @return {*}
 */
export function apiList2 (companyId) {
  let params = { companyId }
  return doHttp('/labelField/detail.action', HTTP_TYPE_GET, params)
}
